const Settings = {
	// apiUrl: "https://patientportalapi.indici.ie/api/",       // live url
	// apiUrl: 'https://nhldevconnect.indici.ie/api/' ,            //  dev url 
	apiUrl : 'https://nhldevconnectsecurity.indici.ie/api',       // security url

	recaptchaKey: "6LdpcwYqAAAAANoAyorsXzdBZS33sXw9OSSx5RAr"
};
export default Settings;

// apiUrl : 'https://stagingindiciconnect.itsmyhealth.nz/api/' https://erxindiciconnect.indici.nz/api/

// 'https://nhldevconnect.indici.ie/api/'
  